<template>
  <modal
    name="RejectCollectingEmail"
    role="dialog"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
    class="m-full"
    :width="300"
    :height="400"
    :maxHeight="740"
    :scrollable="true"
  >
    <div class="dialog__inner">
      <div class="popup-header">
        <h1 id="dialog-title" tabindex="0">이메일주소 무단수집거부</h1>
        <button
          type="button"
          class="btn_popup_close"
          data-dismiss="modal"
          title="팝업닫기"
          @click="closeDialog"
        >
          <span>팝업 닫기</span>
        </button>
      </div>
      <div id="dialog-content" class="dialog__content">
        <div class="section">
          <div class="section-header blind">
            <h3>이메일주소 무단수집거부</h3>
          </div>
          <div class="section-body">
            <dl class="field-group vertical">
              <dt class="field-label">
                <h4 role="heading" tabindex="0">이메일주소 무단수집거부</h4>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub text-detail scrollable">
                  <p role="region" tabindex="0" class="td-term">
                    본 홈페이지에 게시된 이메일 주소가 전자우편이나 수집
                    프로그램이나 그밖의 기술적인 장치를 이용하여 무단으로
                    수집되는 것을 거부하며, 이를 위반시 정보통신망법에 의해
                    형사처벌됨을 유념하시기 바랍니다. <br />
                    게시일 2004년 2월 24일
                  </p>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="dialog__footer">
        <button @click="closeDialog" type="button" class="primary-button">
          확인
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'RejectCollectingEmailPopup',
  methods: {
    /** 
     * Function    : closeDialog
     * Description : Dialog 닫기
     **/
    closeDialog() {
      // const modal = document.getElementById("RejectCollectingEmail")//document.querySelector('checkResult')
      // modal.close()
      this.$modal.hide('RejectCollectingEmail')
    }
  }
}
</script>

<style scoped></style>
